import { render } from "./first.vue?vue&type=template&id=630585ac&scoped=true"
import script from "./first.vue?vue&type=script&lang=js"
export * from "./first.vue?vue&type=script&lang=js"

import "./first.vue?vue&type=style&index=0&id=630585ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630585ac"]])

export default __exports__